import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatLocationSuggestion(address: any): string {
  const parts: string[] = [];
  
  // Get area/locality
  const area = address.suburb || address.neighbourhood || address.village || address.town || address.city;
  if (area) parts.push(area);
  
  // Get state (simplified)
  if (address.state) {
    // Remove "Περιφέρεια" prefix if exists
    const state = address.state.replace('Περιφέρεια ', '');
    if (state !== area) parts.push(state);
  }
  
  // Get postcode
  if (address.postcode) parts.push(address.postcode);
  
  return parts.length > 0 ? parts.join(', ') : '';
}

/**
 * Formats a date with Greek month in accusative case
 * Usage: "από Οκτώβριο 2025" instead of "από Οκτωβρίου 2025"
 */
export const formatGreekDateAccusative = (date: Date): string => {
  const monthsAccusative = [
    'Ιανουάριο', 'Φεβρουάριο', 'Μάρτιο', 'Απρίλιο', 'Μάιο', 'Ιούνιο',
    'Ιούλιο', 'Αύγουστο', 'Σεπτέμβριο', 'Οκτώβριο', 'Νοέμβριο', 'Δεκέμβριο'
  ];
  const month = monthsAccusative[date.getMonth()];
  const year = date.getFullYear();
  return `${month} ${year}`;
};
